import { inject } from "@angular/core";
import { CanActivateChildFn, CanActivateFn, Router } from "@angular/router";
import { filter, first, map, Observable, switchMap } from "rxjs";
import { AuthGuardService } from "./auth-guard.service";

/**
 * The guard function for child routes
 * @returns boolean if a maintenance is active
 */
export const maintenanceGuardChildren = (): CanActivateChildFn => {
    return () => maintenanceGuardFunction();
}

/**
 * The guard function for a single routes
 * @returns boolean if a maintenance is active
 */
export const maintenanceGuardSinglePage = (): CanActivateFn => {
    return () => maintenanceGuardFunction();
}

/**
 * The function that checks if a maintenance is active. It will also navigate to the maintenance page if one is active
 * @returns boolean if a maintenance is active
 */
const maintenanceGuardFunction = (): Observable<boolean> => {
    const authGuardService = inject(AuthGuardService);
    const router = inject(Router);
    return authGuardService.maintenanceIsLoaded().pipe(
        filter(maintenanceIsLoaded => maintenanceIsLoaded),
        switchMap(() => authGuardService.maintenanceIsActive()),
        first(),
        map((maintenanceIsActive) => {
            if (maintenanceIsActive) {
                router.navigate(['/wartungsseite']);
            }
            return !maintenanceIsActive;
        })
    );
}